import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import ErrorBoundary from '@/components/ErrorBoundary';
import Landing from '@/pages/Landing';
import Chat from '@/pages/Chat';
import Report from '@/pages/Report';
import History from '@/pages/History';
import Dashboard from '@/pages/Dashboard';
import Doctors from '@/pages/Doctors';
import Consultations from '@/pages/Consultations';
import UserLogin from '@/pages/UserLogin';
import UserRegister from '@/pages/UserRegister';
import DoctorLogin from '@/pages/DoctorLogin';
import DoctorRegister from '@/pages/DoctorRegister';
import DoctorDashboard from '@/pages/DoctorDashboard';
import HealthResources from '@/pages/HealthResources';
import HealthHub from '@/pages/HealthHub';
import LegalPage from '@/pages/LegalPage';
import { LANGS } from '@/i18n';
import '@/App.css';

function App() {
  const normalizeLang = (value) => (LANGS.some((item) => item.code === value) ? value : 'en');
  const [lang, setLang] = useState(() => normalizeLang(localStorage.getItem('hb_lang')));
  const changeLang = (l) => {
    const next = normalizeLang(l);
    setLang(next);
    localStorage.setItem('hb_lang', next);
  };
  return (
    <ErrorBoundary>
      <div className="App grain min-h-screen">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar lang={lang} setLang={changeLang} />
          <main className="min-w-0">
            <Routes>
              <Route path="/" element={<Landing lang={lang} setLang={changeLang} />} />
              <Route path="/login" element={<UserLogin />} />
              <Route path="/register" element={<UserRegister />} />
              <Route path="/dashboard" element={<Dashboard lang={lang} />} />
              <Route path="/chat" element={<Chat lang={lang} setLang={changeLang} />} />
              <Route path="/report/public/:id" element={<Report lang={lang} publicView />} />
              <Route path="/report/:id" element={<Report lang={lang} />} />
              <Route path="/history" element={<History lang={lang} />} />
              <Route path="/health-hub" element={<HealthHub />} />
              <Route path="/doctors" element={<Doctors lang={lang} />} />
              <Route path="/consultations" element={<Consultations lang={lang} />} />
              <Route path="/abdm" element={<HealthResources page="abdm" />} />
              <Route path="/abha-card" element={<HealthResources page="abha-card" />} />
              <Route path="/phr-apps" element={<HealthResources page="phr" />} />
              <Route path="/privacy" element={<LegalPage type="privacy" />} />
              <Route path="/terms" element={<LegalPage type="terms" />} />
              <Route path="/doctor/login" element={<DoctorLogin />} />
              <Route path="/doctor/register" element={<DoctorRegister />} />
              <Route path="/doctor/dashboard" element={<DoctorDashboard />} />
            </Routes>
          </main>
          <Footer />
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
